<section class="lesson-not-started">
  <div class="message">
    <span>
      <img src="/assets/images/Векторный_смарт-объект_копия.png" alt="Занятие ещё закрыто, зайди чуть позже">
      <div class="message_text">
        <p>Привет, <br> {{ studentName }}! <br></p>
        <p>Занятие ещё закрыто, <br> зайди чуть позже</p>
      </div>
    </span>
    <span><img src="/assets/images/Гермес.png"></span>
  </div>
  <div class="text-center btn-container">
    <button class="btn" (click)="backHistory()">Выйти</button>
  </div>
</section>